<p>department-sales-summary works!</p>
